import { render } from "./BeatLoader.vue?vue&type=template&id=01c48129&scoped=true"
import script from "./BeatLoader.vue?vue&type=script&lang=js"
export * from "./BeatLoader.vue?vue&type=script&lang=js"

import "./BeatLoader.vue?vue&type=style&index=0&id=01c48129&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01c48129"]])

export default __exports__